<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="80px" :model="formLabelAlign">
      <el-form-item label="小程序">
        <el-tag v-if="formLabelAlign.miniprogram_app_id" style="margin-right:10px">{{ miniprogram_wechat_name }}</el-tag>
        <el-button :disabled="type == 2" type="primary" size="mini" @click="choosewecaht">选择小程序</el-button>
      </el-form-item>
      <el-form-item label="管理员组">
        <el-select v-model="formLabelAlign.admin_group_id" placeholder="请选择管理员组">
          <el-option
            v-for="items in options"
            :key="items.id"
            :label="items.title"
            :value="items.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="优先级">
        <el-input v-model="formLabelAlign.rank" type="number" min="0" style="width:200px" placeholder="请输入优先级" @blur="chagerracher" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择绑定的小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <chhosewechat ref="chhosewecahtr" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import chhosewechat from '../../squaredappletSconfigure/components/chhosewechat.vue'
import { getGroupTreeList } from '@/api/authGroup.js'
import { officialAccountmpRankStore, officialAccountmpRankModify } from '@/api/sourceMaterial.js'
export default {
  components: { chhosewechat },
  data() {
    return {
      type: null,
      formLabelAlign: {
        miniprogram_app_id: null,
        admin_group_id: null,
        rank: 0
      },
      miniprogram_wechat_name: '',
      dialogVisiblewechat: false,
      options: [],
      item: {}
    }
  },
  created() {
    this.getapplettype()
  },
  mounted() {

  },
  methods: {
    async getapplettype() {
      const data = await getGroupTreeList()
      this.options = data.data.list
      console.log('data', data)
    },
    send(type, item) {
      this.type = type
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        this.miniprogram_wechat_name = item.account_name
        this.formLabelAlign.miniprogram_app_id = item.miniprogram_app_id
        this.formLabelAlign.admin_group_id = item.admin_group_id
        this.formLabelAlign.rank = item.rank
        this.item = item
      }
      console.log('item', item)
    },
    callback(item) {
      this.dialogVisiblewechat = false
      this.miniprogram_wechat_name = item.account_name
      this.formLabelAlign.miniprogram_app_id = item.app_id
      console.log('item', item)
    },
    choosewecaht() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    async sumbit() {
      console.log(this.formLabelAlign.rank)
      if (this.formLabelAlign.miniprogram_app_id === null) {
        this.$message.error('请选择小程序')
        return
      }
      if (this.formLabelAlign.admin_group_id === null) {
        this.$message.error('请选择管理员组')
        return
      }

      if (this.formLabelAlign.rank === '') {
        this.$message.error('请输入优先级')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        const data = await officialAccountmpRankStore(this.formLabelAlign)
        this.$emit('callback')
        console.log('data', data)
      } else {
        const data = await officialAccountmpRankModify({
          rank: this.formLabelAlign.rank,
          admin_group_id: this.formLabelAlign.admin_group_id,
          id: this.item.id
        })
        this.$emit('callback')
        console.log('data', data)
      }
    },
    chagerracher() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.rank < 0 && this.formLabelAlign.rank != '') {
        this.formLabelAlign.rank = 0
      }
    }
  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
/* @import url(); 引入css类 */
/deep/ .el-input__inner::-webkit-outer-spin-button,
 /deep/ .el-input__inner::-webkit-inner-spin-button {
-webkit-appearance: none;
 }
/deep/ .el-input__inner[type='number'] {
-moz-appearance: textfield;
 }

</style>
